export const COMPANY_NAME = "ASSISTANCE DOGS INTERNATIONAL INC";
export const COMPANY_SHORT = "Assistance Dogs International";
export const COMPANY_INITIALS = "ADI";
export const COMPANY_ADDRESS_FULL = "PO Box 276, Maumee, OH 43537, USA";
export const COMPANY_LOCATION = "Maumee, OH";
export const COMPANY_REGION = "Ohio, United States";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=PO%20Box%20276%2C%20Maumee%2C%20OH%2043537%2C%20USA";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Our focus", "value": "Human–dog partnerships" },
  { "label": "Our community", "value": "A global nonprofit network" },
  { "label": "Our foundation", "value": "Established in 1986" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Nonprofit coalition" },
  { "label": "Founded", "value": "1986" },
  { "label": "Community", "value": "International" },
  { "label": "Mailing location", "value": "Maumee, Ohio" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Shared standards", "body": "Developing standards and ethical guidance for assistance dog organizations." },
  { "icon": "✦", "title": "Accreditation", "body": "Assessing member programs against the standards of the ADI network." },
  { "icon": "✿", "title": "Shared learning", "body": "Helping member organizations exchange knowledge and learn together." },
  { "icon": "❍", "title": "Public awareness", "body": "Sharing information about assistance dogs and the organizations that train them." },
];

export const HERO_TITLE = 'Stronger partnerships. A more connected world.';
export const HERO_DESCRIPTION = 'A global community of nonprofit organizations, working together to advance standards for assistance dogs and the people who partner with them.';
export const ABOUT_TITLE = 'Connected by a shared purpose.';
export const ABOUT_DESCRIPTION = 'Founded in 1986, Assistance Dogs International brings nonprofit assistance dog organizations together through shared standards, accreditation and opportunities to learn from one another.';
export const PROGRAMS_DESCRIPTION = 'From ethical guidance to knowledge sharing, ADI helps its member organizations work toward a common standard.';
export const MEMBER_SEARCH_URL = 'https://assistancedogsinternational.org/member-search/';
export const OFFICIAL_URL = 'https://assistancedogsinternational.org/';
export const CONTACT_EMAIL = 'info@assistancedogsinternational.org';
export const CONTACT_NOTE = 'Looking for an assistance dog? Explore ADI member programs serving your area. ADI coordinates the network; individual member organizations train and place dogs.';
